<script>
import "./dist/css/select2.css"
import "./dist/js/select2.min.js"
import env from '@root/env';

var $ = window.$;

export default {
  name: "Select2Ajax",
  props: {
    url: String,
    selectClass: String,
    value: [String, Number, Array, Object],
    multiple: Boolean,
    resultData: Function,
    placeholder: {default:""},
  },
  data(){
    return {
      data: [],
    }
  },
  computed:{
    urlAjax(){ return this.url.split('?')[0] },
    query(){
      var query = this.url.queryToObject()
      query.token = Gen.getCookie('botk')
      return Gen.objectToQuery(query)
    },
    page(){ return this.$root.page },
  },
  mounted() {
    this.init()
    if(this.value) this.getValue()
  },
  methods:{
    init(){
      setTimeout(()=>{
        $(this.$el)
          .select2({
            ajax: {
              url: env.baseUrl+this.urlAjax+"?"+this.query,
              data:(params)=>{
                var query = {
                  search: params.term,
                  page: params.page || 1
                }
                return query;
              },
              processResults: this.resultData,
            },
            dropdownCssClass: this.selectClass,
            containerCssClass: this.selectClass,
            allowClear: false,
            escapeMarkup: function(m) { return m; }
          })
          .val(this.value)
          // emit event on change.
          .on('change', (resp) => {
            resp.val = this.multiple ? $(this.$el).val() : resp.currentTarget.value;

            this.$emit('change', resp)
            this.$emit('input', (this.multiple ? $(this.$el).val() : resp.currentTarget.value));
            if($(this.$el).closest("form").length) $(this.$el).valid();
          });
          if(!this.value) $(this.$el).next().find(".select2-selection__rendered").text(this.placeholder)
      }, 100)
    },
    getValue(){
      $.ajax({
        url:env.baseUrl+this.urlAjax+"?"+this.query,
        data:{search:this.value},
        success:(resp)=>{
          this.data = this.resultData(resp)
          this.init()
        }
      })
    }
  },
  watch: {
    url(v){
      this.init()
    },
    value(v){
      if(!v){
        $(this.$el).val("")
        return $(this.$el).next().find(".select2-selection__rendered").text(this.placeholder)
      }
      this.getValue()
    }
  },
  destroyed() {
    if($(this.$el).length) $(this.$el).off().select2('destroy');
  }
}
</script>

<template>
  <select :multiple="multiple">
    <option v-for="(v,k) in data.results" :key="k" :value="v.id">{{v.text}}</option>
  </select>
</template>